var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CUIcon',{staticClass:"z-100",class:{
    'w-16 h-16': ['place', 'arrow_downward'].includes(_vm.icon),
    'margin-t-1': _vm.icon === 'place',
    'w-12 h-12': !['place', 'arrow_downward'].includes(_vm.icon),
  },attrs:{"view-box":"0 0 24 24","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }